var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWardrobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21v-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWardrobe);
export default __webpack_public_path__ + "static/media/wardrobe.624b483ef65984559720e4d4a49d8813.svg";
export { ForwardRef as ReactComponent };